import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1254;
const HERO_IMG_HEIGHT = 1254;

/**
 * HERO OPTIMIZADO PARA MOBILE.
 * El mockup se limita por altura de viewport (max-h) además de por ancho, así
 * el precio y el CTA siempre entran en el primer pantallazo sin recortar ni
 * deformar la imagen. En desktop vuelve a la composición texto / mockup.
 */
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-95" data-mp="sa9q98dflju0">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-72 w-[34rem] -translate-x-1/2 rounded-full bg-sand blur-3xl" aria-hidden data-id="element-96" data-mp="nc89iu3h9wlp" />

      <div className="relative mx-auto max-w-md px-5 pb-6 pt-3 text-center sm:max-w-lg sm:pb-10 sm:pt-7 lg:max-w-5xl lg:pb-14 lg:pt-12 lg:text-left" data-id="element-97" data-mp="3d2tnz8hi2ie0">
        <div className="lg:grid lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:items-center lg:gap-12" data-id="element-98" data-mp="3j7zgtn69y0is">
          <div className="animate-hero-copy" data-id="element-99" data-mp="3o7vlzpqpjxzx">
            <p className="font-display text-[0.56rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.66rem]" data-id="element-100" data-mp="3o5j3nbh1flmc">
              El manual más completo y actualizado
            </p>

            <h1 className="mt-1.5 font-display text-[1.75rem] font-extrabold uppercase leading-[0.94] tracking-tight text-charcoal sm:text-[2.3rem] lg:text-[2.9rem]" data-id="element-101" data-mp="3ebirwqr93i4n">
              200 Fórmulas
              <span className="mt-0.5 block font-accent text-[1.15rem] normal-case tracking-normal text-gold-deep sm:text-[1.5rem] lg:text-[1.95rem]" data-id="element-102" data-mp="35a2h4hwixdzw">
                de Jabones Artesanales de Glicerina
              </span>
            </h1>

            <p className="mx-auto mt-2 max-w-[30ch] font-sans text-[0.86rem] font-medium leading-snug text-taupe sm:text-[0.95rem] lg:mx-0 lg:max-w-[34ch]" data-id="element-103" data-mp="2hjf3dfzxfu5f">
              Fabricá jabones hermosos y convertí tu hobby en{' '}
              <strong className="font-bold text-charcoal" data-id="element-104" data-mp="s3349bcaykwh">un ingreso desde casa.</strong>
            </p>

            {/* MOCKUP — en mobile aparece acá, entre el beneficio y la oferta. */}
            <div className="relative my-3 lg:hidden" data-id="element-105" data-mp="ibgnkzh73tmc">
              <img src={HERO_IMG} alt="Colección 200 Fórmulas de Jabones Artesanales de Glicerina: 4 tomos digitales y 5 libros extra de regalo" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 82vw, 380px" style={{
              aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
            }} className="animate-hero-media mx-auto block h-auto max-h-[38vh] w-auto max-w-[20rem] object-contain sm:max-h-[42vh] sm:max-w-[23rem]" data-id="element-106" data-mp="i9vr34bbm0lu" />
            </div>

            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1.5 lg:mt-5 lg:justify-start" data-id="element-107" data-mp="3hr3ptq808136">
              <span className="font-display text-[0.72rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.8rem]" data-id="element-108" data-mp="1xam4cnf59kxc">
                200 fórmulas
              </span>
              <span className="h-1 w-1 rounded-full bg-gold" aria-hidden data-id="element-109" data-mp="269r7y85kc4gd" />
              <span className="font-display text-[0.72rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.8rem]" data-id="element-110" data-mp="2b0fx3gtrspcc">
                4 tomos
              </span>
              <span className="rounded-full bg-gold px-2.5 py-1 font-display text-[0.68rem] font-bold uppercase tracking-[0.06em] text-white sm:text-[0.74rem]" data-id="element-111" data-mp="2g258wyoth71h">
                5 libros extra gratis
              </span>
            </div>

            <p className="mt-3.5 font-display text-[0.6rem] font-bold uppercase tracking-editorial text-taupe sm:text-[0.68rem]" data-id="element-112" data-mp="2u03i7poa6da4">
              Todo el pack completo hoy por
            </p>

            <PriceBlock className="mt-1.5 lg:items-start" layout="inline" size="sm" data-id="element-113" data-mp="zl0zcatqltg6" />

            <div className="mt-3.5 flex justify-center lg:justify-start" data-id="element-114" data-mp="4be0pqxbgttw">
              <CTAButton className="w-full max-w-[24rem] px-4" data-id="element-115" data-mp="4dgw6qh8nf60" />
            </div>
          </div>

          {/* MOCKUP — versión desktop, a la derecha del copy. */}
          <div className="hidden lg:block" data-id="element-116" data-mp="e88vpzudsc3f">
            <img src={HERO_IMG} alt="" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} decoding="async" sizes="460px" style={{
            aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
          }} className="animate-hero-media mx-auto block h-auto max-h-[76vh] w-full max-w-[27rem] object-contain" data-id="element-117" data-mp="e77j3qxpvhjl" />
          </div>
        </div>
      </div>
    </section>;
}